// @ts-check
import { LBButton } from '@linearb/buzz';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';

export const TakeParentConfigButton = ({
  isUsingParentConfig,
  onUseParentConfig,
  parentName
}) => {
  return !isUsingParentConfig ? (
    <div className='mr-2'>
      <LBButton variant='outline' onClick={onUseParentConfig}>
        Use "{parentName}" settings
      </LBButton>
    </div>
  ) : (
    <Flex mr='x-medium' items='center'>
      <Icon name='successOutline' color='funGreen' size='smaller' />
      <Text ml='1rem' size='normal'>
        "{parentName}" setting in use
      </Text>
    </Flex>
  );
};
